
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { format, differenceInDays } from 'date-fns';
import { fr } from 'date-fns/locale';

interface CycleStatsProps {
  lastPeriodDate?: Date;
  cycleLength?: string;
  periodDuration?: string;
}

export const CycleStats = ({ lastPeriodDate, cycleLength, periodDuration }: CycleStatsProps) => {
  if (!lastPeriodDate || !cycleLength || !periodDuration) {
    return null;
  }

  const cycleLengthNum = parseInt(cycleLength);
  const periodDurationNum = parseInt(periodDuration);
  const today = new Date();
  const daysSinceLastPeriod = differenceInDays(today, lastPeriodDate);
  const currentCycleDay = ((daysSinceLastPeriod % cycleLengthNum) + cycleLengthNum) % cycleLengthNum + 1;
  
  const nextPeriodDate = new Date(lastPeriodDate);
  nextPeriodDate.setDate(lastPeriodDate.getDate() + cycleLengthNum);
  while (nextPeriodDate < today) {
    nextPeriodDate.setDate(nextPeriodDate.getDate() + cycleLengthNum);
  }

  const daysUntilNextPeriod = differenceInDays(nextPeriodDate, today);

  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Jour du cycle</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">Jour {currentCycleDay}</div>
          <p className="text-xs text-muted-foreground">
            sur {cycleLengthNum} jours
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Dernières règles</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {format(lastPeriodDate, 'dd MMM', { locale: fr })}
          </div>
          <p className="text-xs text-muted-foreground">
            Durée: {periodDurationNum} jours
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Prochaines règles</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {format(nextPeriodDate, 'dd MMM', { locale: fr })}
          </div>
          <p className="text-xs text-muted-foreground">
            Dans {daysUntilNextPeriod} jours
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
